<template>
    <div class="w-full max-w-[609px]">
        <div
            class="border border-primary p-4 grid gap-y-4 bg-white rounded-2xl"
        >
            <section ref="post" class="flex gap-x-3.5">
                <div class="w-12 h-12 bg-gray-300 rounded-full object-cover">
                    <img
                        :src="perfilPhoto"
                        class="rounded-full h-full w-full"
                        alt=""
                    />
                </div>
                <div>
                    <p class="font-bold text-primary">{{ author }}</p>
                    <p class="text-xs text-gray-500">
                        {{ formatUpdatedDate(createdDate) }}
                    </p>
                </div>
            </section>
            <section v-html="text"></section>
            <a
                class="text-xs xl:text-base text-[#2E59FF] underline"
                :href="url"
                >{{ link }}</a
            >

            <div
                v-if="
                    midia.includes('https://www.youtu') ||
                    midia.includes('https://youtu')
                "
            >
                <a :href="midia" class="text-sm text-blue-700 underline">{{
                    midia
                }}</a>
                <div v-html="videoEmbed"></div>
            </div>
            <div v-else-if="midia.includes('https://vimeo')">
                <div v-html="videoEmbed"></div>
            </div>
            <img v-else :src="midia" class="place-self-center" />
            <div class="flex justify-between">
                <div class="flex items-center gap-x-3">
                    <div
                        @click="likePost()"
                        class="flex gap-x-2 cursor-pointer"
                    >
                        <Icon v-if="dataLiked === 0" name="Curtir" />
                        <Icon v-if="dataLiked === 1" name="CurtirPressionado" />
                        <p
                            class="text-primary text-sm"
                            :class="dataLiked ? 'font-bold' : 'font-regular'"
                        >
                            Curtir
                        </p>
                    </div>
                    <a
                        v-if="!showComments"
                        :href="`news/details/${postId}`"
                        class="flex gap-x-2 items-center cursor-pointer"
                    >
                        <Icon name="Comentar" />
                        <p class="text-primary">Comentar</p>
                    </a>
                    <a v-else class="flex gap-x-2 items-center cursor-pointer">
                        <Icon name="Comentar" />
                        <p class="text-primary">Comentar</p>
                    </a>
                </div>
                <div class="flex gap-x-3">
                    <a
                        v-if="!showComments"
                        :href="`/news/details/${postId}`"
                        class="flex gap-x-2 items-center"
                    >
                        <Icon name="ComentarPreenchido" />
                        <p class="text-primary">{{ amountComment }}</p>
                    </a>
                    <div v-else class="flex gap-x-2 items-center">
                        <Icon name="ComentarPreenchido" />
                        <p class="text-primary">{{ amountComment }}</p>
                    </div>
                    <div class="flex gap-x-2 items-center">
                        <Icon name="CurtirPressionado" />
                        <p class="text-primary">{{ amountLike }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showComments" class="flex flex-col gap-y-2 mt-2">
            <div class="relative">
                <input
                    placeholder="Escreva aqui seu comentário..."
                    type="text"
                    v-model="form.description"
                    @keyup.enter="sendComment()"
                    class="border-primary border rounded w-full selected:border-blue-800 disabled:opacity-50 disabled:border-gray-800 disabled:bg-gray-300 form-textarea"
                />
                <div
                    @click="sendComment()"
                    class="absolute flex items-center justify-center top-0 right-0 border border-primary rounded bg-gray-200 h-full w-[42px] cursor-pointer"
                >
                    <Icon name="Enviar" />
                </div>
            </div>
            <div>
                <div
                    v-for="(comment, key) in comments?.sort(function (a, b) {
                        if (a.createdAt < b.createdAt) {
                            return 1;
                        }
                    })"
                    :key="key"
                    class="bg-white p-4 border border-primary rounded flex flex-col gap-y-2"
                >
                    <section class="flex gap-x-3.5">
                        <div
                            class="w-12 h-12 bg-white rounded-full object-cover border border-primary"
                        >
                            <!-- {{comment.photoUrl}} -->
                            <img
                                :src="comment.photoUrl"
                                class="rounded-full h-full w-full"
                                alt=""
                            />
                        </div>
                        <div>
                            <p class="font-bold text-primary">
                                {{ comment.name }}
                            </p>
                            <p class="text-xs">
                                {{ formatUpdatedDate(comment.createdAt) }}
                            </p>
                        </div>
                    </section>
                    <p>{{ comment.text }}</p>
                    <!-- <div @click="likePost()" class="flex gap-x-2 cursor-pointer">
                        <Icon v-if="liked === 0" name="Curtir"/>
                        <Icon v-if="liked === 1" name="CurtirPressionado"/>
                        <p class="text-primary text-sm" :class="liked ? 'font-bold' : 'font-regular'">Curtir</p>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Icon from "@/Components/UI/Icons/Icon.vue";
import { formatUpdatedDate } from "@/Helpers/masks";
import Input from "@/Components/UI/Form/Input.vue";

export default {
    props: {
        perfilPhoto: String,
        author: String,
        createdDate: String,
        text: String,
        url: String,
        link: String,
        video: String,
        curtir: Boolean,
        midia: String,
        liked: Boolean,
        postId: String,
        showComments: {
            default: false,
            type: Boolean,
        },
        comments: Object,
        amountLike: String,
        amountComment: String,
    },
    components: {
        Icon,
        Input,
    },
    data() {
        return {
            form: this.$inertia.form({
                postId: this.postId,
                description: "",
            }),
            videoEmbed: undefined,
            dataLiked: this.liked,
        };
    },
    methods: {
        sendComment() {
            this.form.post(route("save-post"));
            this.form.description = "";
        },
        likePost() {
            axios
                .post(
                    route("news.like-post"),
                    {
                        postId: this.postId,
                        userId: this.$page.props.auth.user.id,
                    }
                )
                .then(response => {
                    if(response.data.statusCode == 201) {
                        this.dataLiked = response.data.data.liked;
                    }
                })
                .catch(err => {
                    console.log(err);
                })
        },
        formatUpdatedDate,
        convertYoutube(link) {
            function getId(url) {
                const regExp =
                    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
                const match = url.match(regExp);

                return match && match[2].length === 11 ? match[2] : null;
            }

            const videoId = getId(link);
            return (
                '<iframe width="560" height="315" src="//www.youtube.com/embed/' +
                videoId +
                '" frameborder="0" allowfullscreen></iframe>'
            );
        },
        async convertVideo(html) {
            console.log({ html });
            var pattern1 = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
            var pattern2 =
                /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(.+)/g;

            if (pattern1.test(html)) {
                console.log("html", html);

                const { data: vimeoEmbed } = await axios.get(
                    `https://vimeo.com/api/oembed.json?url=${html}`
                );

                console.log(vimeoEmbed);

                return vimeoEmbed?.html;
            }

            if (pattern2.test(html)) {
                console.log("html", html);

                var replacement =
                    '<iframe class="w-full" width="560" height="315" src="http://www.youtube.com/embed/$1" frameborder="0" allowfullscreen></iframe>';

                var html = html.replace(pattern2, replacement);
            }

            return html;
        },
    },
    async mounted() {
        const midia = this.midia;
        var pattern1 = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
        var pattern2 =
            /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(.+)/g;
        if (pattern1.test(midia)) {
            const width = this.$refs.post.clientWidth;
            const { data: vimeoEmbed } = await axios.get(
                `https://vimeo.com/api/oembed.json?url=${midia}&width=${width}`
            );

            this.videoEmbed = vimeoEmbed?.html;
        }


        if (pattern2.test(midia)) {
            var replacement =
                '<iframe class="w-full" width="560" height="315" src="http://www.youtube.com/embed/$1" frameborder="0" allowfullscreen></iframe>';

            this.videoEmbed = midia?.replace(pattern2, replacement);
        }

    },
};
</script>
